import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class DepartmentsSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Departments",
            description              : "The Departments module simplifies team organization by allowing you to categorize and manage team members based on departments or functional areas. You can create and customize departments to reflect your organizational structure, making team management more efficient. By assigning team members to specific departments, you streamline communication, collaboration, and task allocation within your teams.",
            svgIcon                  : "isvg-departments",
            typeLabel                : "Core",
            settingsUrl              : "settings/departments",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.COMPANY_USERS
    }

}
